import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const EmptyDataStyle = {
  wrapper: css`
    width: 100%;
    margin-bottom: 1rem;
    border: 1px solid #ddd;

    border-collapse: collapse;

    th {
      padding: 0.5rem;
      text-align: left;
      border: 1px solid #ddd;

      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;

      color: ${theme.colors.white};
    }

    td {
      padding: 0.5rem;
      color: ${theme.colors.white};
      text-align: left;
      border: 1px solid #ddd;

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  `,
  item: css``,
};
